import { getFromCache, saveToCache, removeFromCache } from "@/utils/cacheUtils";
import api from "@/api";
import esupplyvetApi from "@/api/esupplyvet";
import { useRegisterStore } from "@/stores/register";

function getHttpClient() {
  const registerStore = useRegisterStore();
  const userRole = registerStore.user?.role || "";
  return userRole === "client" ? esupplyvetApi : api;
}

/**
 * Récupère les informations d'un client par son ID
 * @param {number} customerId - ID du client
 * @returns {Promise} Réponse de l'API contenant les infos client
 */
export function getCustomer(customerId) {
  const cacheKey = `customer_${customerId}`;
  const cached = getFromCache(cacheKey);
  if (cached) {
    console.log(`Cache hit pour customer ${customerId}`);
    return Promise.resolve({ data: cached, fromCache: true });
  }
  console.log(`Cache miss pour customer ${customerId}, appel API`);
  return getHttpClient()
    .get(`/customers/${customerId}`)
    .then(response => {
      saveToCache(cacheKey, response.data);
      console.log(`Données customer ${customerId} sauvegardées en cache`);
      return response;
    })
    .catch(error => {
      console.error(`Erreur API pour customer ${customerId}:`, error);
      throw error;
    });
}

/**
 * Met à jour les informations d'un client
 * @param {number} customerId - ID du client
 * @param {Object} customerData - Données à mettre à jour
 * @returns {Promise} Réponse de l'API
 */
export function updateCustomer(customerId, customerData) {
  const response = getHttpClient().put(`/customers/${customerId}`, customerData);
  response
    .then(() => {
      invalidateCustomerCache(customerId);
    })
    .catch(() => {});
  return response;
}

/**
 * Change le mot de passe d'un client
 * @param {number} customerId - ID du client
 * @param {Object} passwordData - Données de mot de passe (currentPassword, newPassword)
 * @returns {Promise} Réponse de l'API
 */
export function changeCustomerPassword(customerId, passwordData) {
  const response = getHttpClient().put(`/customers/${customerId}/password`, passwordData);
  response
    .then(() => {
      invalidateCustomerCache(customerId);
    })
    .catch(() => {});
  return response;
}

/**
 * Fonction utilitaire pour invalider le cache d'un customer
 * @param {number} customerId - ID du client
 */
export function invalidateCustomerCache(customerId) {
  removeFromCache(`veterinaire_${customerId}`);
  removeFromCache(`customer_${customerId}`);
  console.log(`Cache invalidé pour customer ${customerId}`);
}
